export const APP = 'App';
export const SERVICE = 'Service';

export const PURCHASE_OPTION_BY_TYPE = {
  [APP]: {
    numberOfSteps: 5,
    isRecommended: true,
  },
  [SERVICE]: {
    numberOfSteps: 4,
    isRecommended: false,
  },
};
